document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('inquiry-add-popup');
  const popupClose = popup ? popup.querySelector('.inquiry-popup__close') : null;
  const messageEl = popup ? popup.querySelector('.inquiry-popup__message') : null;

  function showPopup(text) {
    if (!popup) return;
    if (messageEl) messageEl.textContent = text || 'Product added to cart';
    popup.style.display = 'flex';
    popup.setAttribute('aria-hidden', 'false');
    // auto hide after 3.5s
    clearTimeout(popup._hideTimeout);
    popup._hideTimeout = setTimeout(hidePopup, 5000);
  }
  function hidePopup() {
    if (!popup) return;
    popup.style.display = 'none';
    popup.setAttribute('aria-hidden', 'true');
  }
  if (popupClose) popupClose.addEventListener('click', hidePopup);

  // Intercept only our inquiry forms (IDs start with inquiry-add-), but fallback to any add-to-cart form
  document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
    // If this is standard add-to-cart you may prefer to skip; we target forms whose id starts with inquiry-add-
    const id = form.getAttribute('id') || '';
    const isInquiry = id.startsWith('inquiry-add-') || form.classList.contains('inquiry-form');
    if (!isInquiry) return;

    // prevent duplicate listener
    if (form.dataset.inquiryBound === '1') return;
    form.dataset.inquiryBound = '1';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      const variantId = variantInput.value;
      const qtyField = form.querySelector('[name="quantity"]');
      const quantity = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity })
        });

        if (!res.ok) {
          showPopup('Could not add product — try again');
          return;
        }

        // You can show product title if available
        const productTitleEl = form.closest('.card-wrapper')?.querySelector('.card__heading a');
        const title = productTitleEl ? productTitleEl.textContent.trim() : 'Product added to cart';
        showPopup(`${title} added to cart`);
      } catch (err) {
        console.error('Inquiry add error:', err);
        showPopup('Network error — try again');
      }
    });
  });
});
